// project-imports
import { getRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - CONTACT FORM (PORTAL) ||============================== //

export async function handleContactForm(action: APIAction) {
  switch (action.method) {
    case 'list':
      return getRequest(`/portal/contact-form?agent-id=${action.data.agentId}`);
    default:
      console.info('[ApiManager > handleApiAction > handleContactForm] - Unknown method');
      break;
  }
}
